// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialogTitle {
    font-family: "Bebas Neue", sans-serif;
    font-size: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #A9A9A9;
}
.inputContainer{
    display: flex;
    flex-direction: column;
    align-items: start;
}
.messageContainer{
    display: flex;
    flex-direction: column;
    align-items: start;
}
.dialogRow3{
    display: flex;
    align-items: center;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Donation/ContactUsDialog/ContactUsDialog.css"],"names":[],"mappings":"AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap\");\n\n.dialogTitle {\n    font-family: \"Bebas Neue\", sans-serif;\n    font-size: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #A9A9A9;\n}\n.inputContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n}\n.messageContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n}\n.dialogRow3{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
